// Apis/categories.js
import { apiRequest } from "../services/apiRequest";

export const CategoriesApi = {
  getCategories: async () => {
    const response = await apiRequest("get", `/api/get_categories/`);
    return response?.data || []; // Safe fallback to empty array
  },
};
